<template>
	<v-card flat class="ma-0">
		<v-form ref="form" @submit.prevent>
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters justify="center">
				<v-col cols="12" lg="4">
					<IncrementalSearchForm
						:label="'製造番号'"
						:classArray="['mt-4', 'mr-2']"
						:value.sync="q.order_individual_info_id_eq"
						:itemText="'get_product_info'"
						:targetName="'製品'"
						:url="`/erp/v1/incremental/order_individual_infos`"
					/>
				</v-col>
				<v-col cols="12" lg="8">
					<v-row no-gutters>
						<v-checkbox
							class="mt-4 mr-2"
							label="自身の関係しているものに絞る"
							v-model="q.user_id_or_issuer_id_or_check_units_user_id_eq"
							:value="$store.getters['auth/authData'].id"
						/>
						<v-checkbox
							class="mt-4 mr-2"
							label="完了済みも表示"
							v-model="q.status_not_eq"
							:value="'completed'"
						/>
						<v-checkbox
							class="mt-4 mr-2"
							label="下書きのみ表示"
							v-model="q.status_eq"
							:value="'draft'"
						/>
					</v-row>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="searchCheckSheets" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"

export default {
	props: {
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	components: {
		IncrementalSearchForm,
	},
	data() {
		return {
			dialog: false,
			q: {
				order_individual_info_id_eq: null,
				user_id_or_issuer_id_or_check_units_user_id_eq: null,
				status_not_eq: null,
				status_eq: null,
			},
		}
	},
	mounted() {
		this.q = this.query
	},
	methods: {
		searchCheckSheets() {
			this.$emit("search-check-sheets", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>